module.exports = __webpack_public_path__ + "static/img/11.0afb020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/11.png
// module id = +oyc
// module chunks = 0